import { Attribute } from '../../../concepts/objects';
import { Assignable } from './Assignable';

export interface TaskRecord {
    id: string;
    summary: string;
    dueDate: string;
    status: string;
    userId: string;
}

export const TaskRecordAttr = new Attribute<TaskRecord, Assignable>('taskRecord', null);

export const TaskOpenAttr = new Attribute<boolean, Assignable>('taskOpen', false);
